import DropdownMenuDivider from "components/Menus/DropdownMenuDivider";
import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import PopoverDropdownMenu from "components/Menus/PopoverDropdownMenu";
import ItemWithOptions from "./ItemWithOptions";
import { GetRecordName } from "../../../../utils/RecordUtils";

const MultiReferenceOptions = ({
  name,
  value,
  field,
  onView,
  onRemove,
  isSubitem,
}) => {
  return (
    <PopoverDropdownMenu>
      <h5
        style={{ maxWidth: 250 }}
        className="px-2 pt-2 text-dark text-truncate"
      >
        {name}
      </h5>
      <DropdownMenuDivider />
      <DropdownOptionWithIcon
        name={`View ${isSubitem ? "Subitem" : "Record"}`}
        icon="mdi mdi-eye"
        onClick={() => onView(value)}
      />
      <DropdownMenuDivider />
      <DropdownOptionWithIcon
        name={`Remove ${field?.Name}`}
        icon="mdi mdi-delete"
        onClick={() => onRemove(value)}
      />
    </PopoverDropdownMenu>
  );
};

const SelectedReference = ({
  record,
  field,
  onRemove,
  onView,
  setKeepOpen,
  noBorder,
  modulesMap,
}) => {
  const module = modulesMap.get(record?._ModuleAPIName);
  let name = GetRecordName(module?.Module, record);

  return (
    <ItemWithOptions
      name={name || "(No Name)"}
      options={
        <MultiReferenceOptions
          name={name || "(No Name)"}
          value={record}
          field={field}
          onView={onView}
          onRemove={onRemoveWrapper}
          isSubitem={!!record?._isSubitem}
        />
      }
      onOpen={() => setKeepOpen(true)}
      border={!noBorder}
    />
  );

  function onRemoveWrapper() {
    onRemove();
    setKeepOpen(false);
  }
};

export default SelectedReference;
